﻿﻿if (!customElements.get('purchase-options')) {
  class PurchaseOptions extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      product: "[data-main-product]",
      sellingPlans: "[data-selling-plan-selector]",
      optionsList: ".product__purchase-options-list",
      loading: ".product__purchase-options-loading",
      error: ".product__purchase-options-error"
    };
    this.productBase = false;
    this.storeId = 1;
    this.useStaticData = false; 
    const productContainer = this.closest(this.selectors.product);
    this.productSelector = productContainer ? productContainer.querySelector("product-selector") : null;
    if (!this.productSelector) {
      this.productSelector = this.closest(this.selectors.product);
      this.productBase = true;
    }
    const productFormContainer = this.closest(this.selectors.product);
    this.productForm = productFormContainer ? productFormContainer.querySelector("product-form") : null;
    this._purchaseInfoAbortController = null;
    this._currentSellingPlanId = '';
  }
  connectedCallback() {
    if (!window.ApiClient) {
      console.error('❌ ApiClient not found! Make sure api-client.js is loaded before purchase-options.js');
    }
    this.loadSubscriptionPlans();
    var self = this;
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      this._variantChangeUnsub = subscribe(PUB_SUB_EVENTS.variantChange, function(event) {
        var sectionEl = self.closest('[data-section]');
        if (!sectionEl || event.data.sectionId !== sectionEl.dataset.section) return;
        var checkedRadio = self.querySelector('[name="selling_plan"]:checked');
        var selectedOption = self.querySelector('.product__purchase-option-item.is-selected') || (checkedRadio && checkedRadio.closest('.product__purchase-option-item'));
        self.updateMainPrice(selectedOption || null);
      });
    }
  }
  disconnectedCallback() {
    if (this._variantChangeUnsub) {
      this._variantChangeUnsub();
      this._variantChangeUnsub = null;
    }
  }
  extractNumericId(gid) {
    if (!gid) return '';
    const match = gid.match(/\/(\d+)$/);
    return match ? match[1] : gid;
  }
  async loadSubscriptionPlans() {
    const loadingEl = this.querySelector(this.selectors.loading);
    const optionsListEl = this.querySelector(this.selectors.optionsList);
    const errorEl = this.querySelector(this.selectors.error);
    if (this.useStaticData) {
      this.loadStaticData();
      return;
    }
    const productId = this.dataset.productId;
    const fallbackProductId = '8394129768630'; 
    if (!productId) {
      this.showError('No Product GID');
      return;
    }
    try {
      loadingEl.style.display = 'block';
      optionsListEl.style.display = 'none';
      errorEl.style.display = 'none';
      const result = await window.ApiClient.getSubscriptionPlans(this.storeId, productId);
      const hasSubscriptionPlans = result.status === 200 
        && result.data 
        && result.data.product 
        && result.data.product.sellingPlanGroups 
        && result.data.product.sellingPlanGroups.edges 
        && result.data.product.sellingPlanGroups.edges.length > 0;
      if (!hasSubscriptionPlans) {
        const purchaseOptionsWrapper = this.closest('.product__purchase-options');
        if (purchaseOptionsWrapper) {
          purchaseOptionsWrapper.style.display = 'none';
        }
        loadingEl.style.display = 'none';
        return;
      }
      if (result.status !== 200 || !result.data || !result.data.product) {
        throw new Error('API return data format error');
      }
      const purchaseOptionsWrapper = this.closest('.product__purchase-options');
      if (purchaseOptionsWrapper) {
        purchaseOptionsWrapper.style.display = '';
      }
      try {
        this.renderPurchaseOptions(result.data.product);
        if (this.closest('quick-cart-drawer')) {
          this.updateQuickCartSubmitButton();
        }
      } catch (renderError) {
        if (renderError.message.includes('toggleSubmitButton') ||
            renderError.message.includes('toggleAddButton') ||
            renderError.message.includes('addSubscriptionToCart')) {
        } else {
          throw renderError;
        }
      }
      loadingEl.style.display = 'none';
      optionsListEl.style.display = 'block';
    } catch (error) {
      const purchaseOptionsWrapper = this.closest('.product__purchase-options');
      if (purchaseOptionsWrapper) {
        purchaseOptionsWrapper.style.display = 'none';
      }
      loadingEl.style.display = 'none';
    }
  }
  loadStaticData() {
    const loadingEl = this.querySelector(this.selectors.loading);
    const optionsListEl = this.querySelector(this.selectors.optionsList);
    const staticData = {
      id: "gid://shopify/Product/123456",
      title: "Example Product",
      sellingPlanGroups: {
        edges: [
          {
            node: {
              id: "gid://shopify/SellingPlanGroup/123456",
              name: "Subscription Plan",
              sellingPlans: {
                edges: [
                  {
                    node: {
                      id: "gid://shopify/SellingPlan/123456",
                      name: "Every 1 month - 50% off",
                      category: "SUBSCRIPTION",
                      options: ["Deliver every 1 month"],
                      billingPolicy: {
                        __typename: "SellingPlanRecurringBillingPolicy",
                        interval: "MONTH",
                        intervalCount: 1
                      },
                      deliveryPolicy: {
                        __typename: "SellingPlanRecurringDeliveryPolicy",
                        interval: "MONTH",
                        intervalCount: 1
                      },
                      pricingPolicies: [
                        {
                          __typename: "SellingPlanFixedPricingPolicy",
                          adjustmentType: "PERCENTAGE",
                          adjustmentValue: {
                            __typename: "SellingPlanPricingPolicyPercentageValue",
                            percentage: 50
                          }
                        }
                      ]
                    }
                  }
                ]
              }
            }
          }
        ]
      }
    };
    this.renderPurchaseOptions(staticData);
    loadingEl.style.display = 'none';
    optionsListEl.style.display = 'block';
  }
  showError(message) {
    const loadingEl = this.querySelector(this.selectors.loading);
    const optionsListEl = this.querySelector(this.selectors.optionsList);
    const errorEl = this.querySelector(this.selectors.error);
    loadingEl.style.display = 'none';
    optionsListEl.style.display = 'none';
    errorEl.style.display = 'block';
    errorEl.querySelector('p').textContent = message;
  }
  setHandlers() {
    this.querySelectorAll(this.selectors.sellingPlans).forEach(
      radioButton =>
        radioButton.addEventListener("change", this.onSellingPlanChange.bind(this))
    );
  }
  renderPurchaseOptions(data) {
    const optionsListEl = this.querySelector(this.selectors.optionsList);
    const currentPrice = parseFloat(this.dataset.currentPrice) / 100;
    const compareAtPrice = parseFloat(this.dataset.compareAtPrice || 0) / 100;
    const productFormId = this.dataset.productFormId;
    const oneTimeLabel = this.dataset.oneTimeLabel || 'Get Once';
    const showOneTime = this.dataset.showOneTime !== 'false';
    let html = '';

    const allPlansWithGroup = [];
    const edges = data.sellingPlanGroups?.edges || [];
    for (let i = 0; i < edges.length; i++) {
      const group = edges[i]?.node;
      if (!group) continue;
      const planEdges = group.sellingPlans?.edges || [];
      for (let j = 0; j < planEdges.length; j++) {
        const plan = planEdges[j]?.node;
        if (plan) {
          allPlansWithGroup.push({ plan, groupName: group.name || '' });
        }
      }
    }

    if (allPlansWithGroup.length === 0) {
      const purchaseOptionsWrapper = this.closest('.product__purchase-options');
      if (purchaseOptionsWrapper) {
        purchaseOptionsWrapper.style.display = 'none';
      }
      return;
    }

    for (let idx = 0; idx < allPlansWithGroup.length; idx++) {
      const { plan } = allPlansWithGroup[idx];
      const planLabel = plan.name || 'Subscribe to Save';
      const benefitsArray = plan.options || [];
      let subscriptionPrice = currentPrice;
      let discountPercentage = 0;
      if (plan.pricingPolicies && plan.pricingPolicies.length > 0) {
        const pricingPolicy = plan.pricingPolicies[0];
        if (pricingPolicy.__typename === 'SellingPlanFixedPricingPolicy' && pricingPolicy.adjustmentValue) {
          if (pricingPolicy.adjustmentType === 'PERCENTAGE') {
            discountPercentage = pricingPolicy.adjustmentValue.percentage || 0;
            subscriptionPrice = currentPrice * (1 - discountPercentage / 100);
          } else if (pricingPolicy.adjustmentType === 'PRICE' && pricingPolicy.adjustmentValue.amount != null) {
            const amountOff = parseFloat(pricingPolicy.adjustmentValue.amount) || 0;
            subscriptionPrice = Math.max(0, currentPrice - amountOff);
            if (currentPrice > 0) {
              discountPercentage = Math.round((amountOff / currentPrice) * 100);
            }
          }
        }
      }
      let deliveryFrequency = '';
      if (plan.deliveryPolicy && plan.deliveryPolicy.interval) {
        const intervalCount = plan.deliveryPolicy.intervalCount || 1;
        const interval = plan.deliveryPolicy.interval.toLowerCase();
        const intervalText = {
          'day': 'Day',
          'week': 'Week',
          'month': 'Monthly',
          'year': 'Yearly'
        }[interval] || interval;
        if (intervalCount === 1) {
          deliveryFrequency = `Delivered ${intervalText}`;
        } else {
          deliveryFrequency = `Delivered Every ${intervalCount} ${intervalText}`;
        }
      }
      const numericPlanId = this.extractNumericId(plan.id);
      html += `
              <label class="product__purchase-option-item" data-option-type="subscription" data-plan-id="${plan.id}">
                <input
                  type="radio"
                  name="selling_plan"
                  value="${numericPlanId}"
                  data-id="Product-Purchase-Option-${numericPlanId}"
                  data-selling-plan-selector
                  form="${productFormId}"
                >
                <div class="product__purchase-option-left">
                  <div class="product__purchase-option-main">
                    <span class="product__purchase-option-checkbox"></span>
                    <span class="product__purchase-option-label">${planLabel}</span>
                  </div>
                  ${benefitsArray.length > 0 ? `
                    <ul class="product__purchase-option-benefits">
                      ${benefitsArray.map(benefit => `
                        <li>
                          <svg class="product__purchase-option-benefit-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13.3333 4L6 11.3333L2.66667 8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                          ${benefit}
                        </li>
                      `).join('')}
                    </ul>
                  ` : ''}
                </div>
                <div class="product__purchase-option-right">
                  <div class="product__purchase-option-price-wrapper">
                    <span class="product__purchase-option-price">$${subscriptionPrice.toFixed(2)}</span>
                    ${discountPercentage > 0 ? `<span class="product__purchase-option-badge product__purchase-option-badge--discount">${Math.round(discountPercentage)}% OFF SALE</span>` : ''}
                  </div>
                  ${deliveryFrequency ? `
                    <div class="product__purchase-option-delivery">
                      ${deliveryFrequency}
                    </div>
                  ` : ''}
                </div>
              </label>
            `;
    }

    if (showOneTime) {
      const oneTimeCompareAtPrice = compareAtPrice > currentPrice ? compareAtPrice : this.getFallbackCompareAtPrice(currentPrice);
      html += `
        <label class="product__purchase-option-item is-selected" data-option-type="one-time">
          <input
            type="radio"
            name="selling_plan"
            value=""
            data-id="Product-Purchase-Option-one-time"
            data-selling-plan-selector
            checked
            form="${productFormId}"
          >
          <div class="product__purchase-option-left">
            <div class="product__purchase-option-main">
              <span class="product__purchase-option-checkbox"></span>
              <span class="product__purchase-option-label">${oneTimeLabel}</span>
            </div>
          </div>
          <div class="product__purchase-option-right">
            <div class="product__purchase-option-price-wrapper">
              ${oneTimeCompareAtPrice > currentPrice ? `<s class="product__purchase-option-compare-at">$${oneTimeCompareAtPrice.toFixed(2)}</s> ` : ""}<span class="product__purchase-option-price">$${currentPrice.toFixed(2)}</span>
            </div>
          </div>
        </label>
      `;
    }
    
    optionsListEl.innerHTML = html;
    this.setHandlers();
    const firstCheckedRadio = this.querySelector('[name="selling_plan"]:checked');
    if (firstCheckedRadio) {
      const sellingPlanId = firstCheckedRadio.value;
      const selectedOption = firstCheckedRadio.closest('.product__purchase-option-item');
      try {
        this.updateMainPrice(selectedOption);
        this.updateProductSelector(sellingPlanId);
      } catch (e) {
        console.warn(e.message);
      }
    }
  }
  onSellingPlanChange(event) {
    const selectedValue = event.target.value;
    this._currentSellingPlanId = selectedValue;
    const purchaseOptionsContainer = this;
    purchaseOptionsContainer.querySelectorAll('.product__purchase-option-item').forEach(item => {
      item.classList.remove('is-selected');
    });
    const itemElement = event.target.closest('.product__purchase-option-item');
    if (itemElement) itemElement.classList.add('is-selected');
    if (selectedValue == "" || selectedValue == "one-time") {
      purchaseOptionsContainer.querySelectorAll('.product__purchase-option-custom-text').forEach(customText => {
        customText.classList.add('is-hidden');
      });
      this.updateMainPrice();
      this.updateProductSelector();
      if (this.closest('quick-cart-drawer')) {
        this.updateQuickCartSubmitButton();
      }
      return;
    }
    const selectedOption = event.target.closest('.product__purchase-option-item');
    if (selectedOption) {
      const customText = selectedOption.querySelector('.product__purchase-option-custom-text');
      if (customText) {
        customText.classList.remove('is-hidden');
      }
    }
    purchaseOptionsContainer.querySelectorAll('.product__purchase-option-item').forEach(item => {
      if (item !== selectedOption) {
        const customText = item.querySelector('.product__purchase-option-custom-text');
        if (customText) {
          customText.classList.add('is-hidden');
        }
      }
    });
    this.updateMainPrice(selectedOption);
    this.updateProductSelector(selectedValue);
    if (this.closest('quick-cart-drawer')) {
      this.updateQuickCartSubmitButton();
    }
  }
  isOneTimePurchase() {
    const selectedRadio = this.querySelector('[name="selling_plan"]:checked');
    return selectedRadio && (selectedRadio.value === "" || selectedRadio.value === "one-time");
  }
  updateQuickCartSubmitButton() {
    const drawer = this.closest('quick-cart-drawer');
    if (!drawer || !window.variantStrings) return;
    const form = drawer.querySelector('#quick-cart-product-form');
    if (!form) return;
    const submitBtn = form.querySelector('button[type="submit"]');
    if (!submitBtn) return;
    const textSpan = submitBtn.querySelector('span');
    if (!textSpan) return;
    const isSubscription = !this.isOneTimePurchase();
    if (form.hasAttribute('data-has-pre-order')) {
      textSpan.textContent = window.variantStrings.preOrder || 'Preorder';
    } else if (isSubscription) {
      textSpan.textContent = window.variantStrings.addSubscriptionToCart || 'Add subscription to cart';
    } else {
      textSpan.textContent = window.variantStrings.addToCart || 'Add to cart';
    }
  }
  getFallbackCompareAtPrice(currentPrice) {
    const sectionElement = this.closest('[data-section]');
    const variantId = sectionElement?.querySelector('input[name="id"]')?.value;
    if (!variantId) return 0;
    const script = document.getElementById(`subscriptions_money_with_currency_one_time_purchase_${variantId}`);
    if (!script) return 0;
    try {
      const data = JSON.parse(script.textContent || '{}');
      const raw = data.comparedAtPrice || data.compareAtPrice || '';
      const numeric = parseFloat(String(raw).replace(/[^0-9.]/g, ''));
      return Number.isFinite(numeric) && numeric > currentPrice ? numeric : 0;
    } catch (error) {
      return 0;
    }
  }

  syncOneTimeCompareAtPrice() {
    const currentPrice = parseFloat(this.dataset.currentPrice || 0) / 100;
    const fallbackCompareAtPrice = this.getFallbackCompareAtPrice(currentPrice);
    if (fallbackCompareAtPrice > currentPrice) {
      this.dataset.compareAtPrice = String(Math.round(fallbackCompareAtPrice * 100));
    }
  }
  updateMainPrice(selectedOption = null) {
    this.syncOneTimeCompareAtPrice();
    const sectionElement = this.closest('[data-section]');
    if (!sectionElement) return;
    const priceContainer = document.querySelector('#price-' + sectionElement.dataset.section);
    if (!priceContainer) return;
    
    const currentPrice = parseFloat(this.dataset.currentPrice) / 100;
    const compareAtPrice = parseFloat(this.dataset.compareAtPrice || 0) / 100;
    
    const priceElement = priceContainer.querySelector('.price__container');
    if (!priceElement) return;
    
    const priceBadgesElement = priceContainer.querySelector('.product__price-badges');
    if (priceBadgesElement) this._cachedPriceBadgesHtml = priceBadgesElement.outerHTML;
    const priceBadgesHtml = priceBadgesElement ? priceBadgesElement.outerHTML : (this._cachedPriceBadgesHtml || '');
    
    if (!selectedOption || selectedOption.dataset.optionType === 'one-time') {
      if (compareAtPrice > 0 && compareAtPrice > currentPrice) {
        priceElement.innerHTML = `
          <div class="price__sale">
            <div class="price__sale-inner">
              <span class="visually-hidden">Regular price</span>
              <s>$${compareAtPrice.toFixed(2)}</s>
              <ins>
                <span class="visually-hidden">Sale price</span>
                <span>$${currentPrice.toFixed(2)}</span>
              </ins>
              ${priceBadgesHtml}
            </div>
          </div>
        `;
      } else {
        priceElement.innerHTML = `
          <div class="price__regular">
            <span class="visually-hidden">Regular price</span>
            <span>$${currentPrice.toFixed(2)}</span>
            ${priceBadgesHtml}
          </div>
        `;
      }
      return;
    }
    
    const priceWrapper = selectedOption.querySelector('.product__purchase-option-price-wrapper');
    const subscriptionPrice = priceWrapper ? priceWrapper.querySelector('.product__purchase-option-price').textContent : `$${currentPrice.toFixed(2)}`;
    const badge = priceWrapper ? priceWrapper.querySelector('.product__purchase-option-badge') : null;
    let badgeHtml = '';
    if (badge && badge.textContent) {
      badgeHtml = `<span class="product__purchase-option-badge product__purchase-option-badge--discount">${badge.textContent}</span>`;
    }
    
    const originalPrice = compareAtPrice > 0 ? compareAtPrice : currentPrice;
    priceElement.innerHTML = `
      <div class="price__sale">
        <div class="price__sale-inner">
          <span class="visually-hidden">Regular price</span>
          <s>$${originalPrice.toFixed(2)}</s>
          <ins>
            <span class="visually-hidden">Sale price</span>
            <span>${subscriptionPrice}</span>
          </ins>
          ${priceBadgesHtml}
          ${badgeHtml}
        </div>
      </div>
    `;
  }
  
  updateProductSelector(sellingPlanId) {
    if (!this.productSelector || !this.productForm) {
      return;
    }
    if (this.productBase) {
      this.updateProductBase(sellingPlanId);
      return;
    }
    if (!this.productSelector.currentVariant) {
      if (typeof this.productSelector.updateVariant === 'function') {
        this.productSelector.updateVariant();
      }
    }
    if (typeof this.productSelector.updateURL === 'function') {
      this.productSelector.updateURL(sellingPlanId);
    }
    if (typeof this.productSelector.renderProductInfo === 'function') {
      this.productSelector.renderProductInfo();
    }
    if (
      this.productSelector.currentVariant && this.productSelector.currentVariant.available &&
      sellingPlanId
    ) {
      this.productForm.setAttribute("data-has-selling-plan", "true");
      try {
        if (typeof this.productForm.toggleAddButton === 'function') {
          this.productForm.toggleAddButton(false, "");
        }
      } catch (e) {
        console.warn('⚠️ toggleAddButton error:', e.message);
      }
      return;
    }
    this.productForm.removeAttribute("data-has-selling-plan");
    try {
      if (typeof this.productForm.toggleAddButton === 'function') {
        this.productForm.toggleAddButton(false, "");
      }
    } catch (e) {
      console.warn('⚠️ toggleAddButton error:', e.message);
    }
  }
  updateProductBase(sellingPlanId) {
    if (!this.productSelector || !this.productForm) {
      console.warn('⚠️ Product selector or form not found');
      return;
    }
    const selectedVariant = typeof this.productSelector.getSelectedVariant === 'function' 
      ? this.productSelector.getSelectedVariant(this.productSelector) 
      : null;
    if (!selectedVariant) {
      console.warn('⚠️ No selected variant');
      return;
    }
    if (typeof this.productSelector.updateSellingPlanURL === 'function') {
      this.productSelector.updateSellingPlanURL(sellingPlanId, selectedVariant.id);
    }
    this.renderPurchaseInfo(selectedVariant.id, sellingPlanId);
    if (selectedVariant.available && sellingPlanId) {
      this.productForm.setAttribute("data-has-selling-plan", "true");
      try {
        if (typeof this.productForm.toggleSubmitButton === 'function') {
          this.productForm.toggleSubmitButton(false, "");
        }
      } catch (e) {
        console.warn('⚠️ toggleSubmitButton error:', e.message);
      }
      return;
    }
    this.productForm.removeAttribute("data-has-selling-plan");
    try {
      if (typeof this.productForm.toggleSubmitButton === 'function') {
        this.productForm.toggleSubmitButton(false, "");
      }
    } catch (e) {
      console.warn('⚠️ toggleSubmitButton error:', e.message);
    }
  }
  renderPurchaseInfo(selectedVariantId, sellingPlanId) {
    if (!this.productSelector || !this.productSelector.dataset || !this.productSelector.dataset.url) {
      return;
    }
    this._currentSellingPlanId = sellingPlanId != null ? String(sellingPlanId) : (this.querySelector('[name="selling_plan"]:checked')?.value ?? '');
    this._purchaseInfoAbortController?.abort();
    this._purchaseInfoAbortController = new AbortController();
    const signal = this._purchaseInfoAbortController.signal;
    const params = new URLSearchParams(window.location.search);
    params[params.has("variant") ? "set" : "append"](
      "variant",
      selectedVariantId
    );
    const self = this;
    fetch(`${this.productSelector.dataset.url}?${params.toString()}`, { signal })
      .then(response => response.text())
      .then(responseText => {
        if (signal.aborted) return;
        const html = new DOMParser().parseFromString(
          responseText,
          "text/html"
        );
        const purchaseInfoSelector = `#ProductPurchaseInfo-${self.productSelector.dataset.section}`;
        const destination = document.querySelector(purchaseInfoSelector);
        const source = html.querySelector(purchaseInfoSelector);
        if (destination && source) {
          destination.classList.remove("hidden");
          destination.innerHTML = source.innerHTML;
        }
        
        const newPurchaseOptions = html.querySelector('purchase-options');
        if (newPurchaseOptions) {
          const newCurrentPrice = newPurchaseOptions.dataset.currentPrice;
          const newCompareAtPrice = newPurchaseOptions.dataset.compareAtPrice;
          if (newCurrentPrice) self.dataset.currentPrice = newCurrentPrice;
          if (newCompareAtPrice) self.dataset.compareAtPrice = newCompareAtPrice;
        }
        
        var planToRestore = self._currentSellingPlanId;
        if (planToRestore) {
          var radioToSelect = self.querySelector('[name="selling_plan"][value="' + planToRestore + '"]');
          if (radioToSelect) {
            radioToSelect.checked = true;
            self.querySelectorAll('.product__purchase-option-item').forEach(function(item) {
              item.classList.remove('is-selected');
            });
            var labelItem = radioToSelect.closest('.product__purchase-option-item');
            if (labelItem) {
              labelItem.classList.add('is-selected');
              self.updateMainPrice(labelItem);
            } else {
              self.updateMainPrice();
            }
          } else {
            self._currentSellingPlanId = '';
            self.updateMainPrice();
          }
        } else {
          self.updateMainPrice();
        }
      })
      .catch(function(error) {
        if (error.name === 'AbortError') return;
        console.error('Error fetching purchase info:', error);
      });
    }
  }
  customElements.define('purchase-options', PurchaseOptions);
}





